import {
  fetchResource,
  fetchCollection,
  createResource,
  deleteResource,
  performActionOnResource
} from './index'

import { qaWorkOrderSchema as schema } from '../schemas'

const singleKey = 'qaWorkOrder'
const multipleKey = 'qaWorkOrders'

export const QA_WORK_ORDERS_REQUEST = 'QA_WORK_ORDERS_REQUEST'
export const QA_WORK_ORDERS_SUCCESS = 'QA_WORK_ORDERS_SUCCESS'
export const QA_WORK_ORDERS_FAILURE = 'QA_WORK_ORDERS_FAILURE'

function fetchQAWorkOrders (url, reload) {
  return fetchCollection({
    url,
    key: multipleKey,
    actions: [QA_WORK_ORDERS_REQUEST, QA_WORK_ORDERS_SUCCESS, QA_WORK_ORDERS_FAILURE],
    schema,
    responseInterceptor: (response) => ({ ...response, reload })
  })
}

export function loadQAWorkOrders (nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = getState().pagination.qaWorkOrders

    if (!nextPage) {
      nextPageUrl = '/qa_work_orders'
    }

    return dispatch(fetchQAWorkOrders(nextPageUrl, !nextPage))
  }
}

export const QA_WORK_ORDER_REQUEST = 'QA_WORK_ORDER_REQUEST'
export const QA_WORK_ORDER_SUCCESS = 'QA_WORK_ORDER_SUCCESS'
export const QA_WORK_ORDER_FAILURE = 'QA_WORK_ORDER_FAILURE'

export function fetchQAWorkOrder (id) {
  return fetchResource({
    url: `/qa_work_orders/${id}`,
    key: singleKey,
    actions: [QA_WORK_ORDER_REQUEST, QA_WORK_ORDER_SUCCESS, QA_WORK_ORDER_FAILURE],
    schema
  })
}

export const CREATE_QA_WORK_ORDER_REQUEST = 'CREATE_QA_WORK_ORDER_REQUEST'
export const CREATE_QA_WORK_ORDER_SUCCESS = 'CREATE_QA_WORK_ORDER_SUCCESS'
export const CREATE_QA_WORK_ORDER_FAILURE = 'CREATE_QA_WORK_ORDER_FAILURE'

export function createQAWorkOrder (data) {
  return createResource({
    url: '/qa_work_orders',
    key: singleKey,
    actions: [CREATE_QA_WORK_ORDER_REQUEST, CREATE_QA_WORK_ORDER_SUCCESS, CREATE_QA_WORK_ORDER_FAILURE],
    schema,
    data
  })
}

export const DELETE_QA_WORK_ORDER_REQUEST = 'DELETE_QA_WORK_ORDER_REQUEST'
export const DELETE_QA_WORK_ORDER_SUCCESS = 'DELETE_QA_WORK_ORDER_SUCCESS'
export const DELETE_QA_WORK_ORDER_FAILURE = 'DELETE_QA_WORK_ORDER_FAILURE'

export function deleteQAWorkOrder (qaWorkOrderId) {
  return deleteResource({
    url: `/qa_work_orders/${qaWorkOrderId}`,
    actionPayload: { resourceId: qaWorkOrderId },
    actions: [ DELETE_QA_WORK_ORDER_REQUEST, DELETE_QA_WORK_ORDER_SUCCESS, DELETE_QA_WORK_ORDER_FAILURE ]
  })
}

export const SUBMIT_QA_WORK_ORDER_REQUEST = 'SUBMIT_QA_WORK_ORDER_REQUEST'
export const SUBMIT_QA_WORK_ORDER_SUCCESS = 'SUBMIT_QA_WORK_ORDER_SUCCESS'
export const SUBMIT_QA_WORK_ORDER_FAILURE = 'SUBMIT_QA_WORK_ORDER_FAILURE'

export function submitQAWorkOrder (qaWorkOrderId) {
  return performActionOnResource({
    url: `/qa_work_orders/${qaWorkOrderId}`,
    action: 'submit',
    key: singleKey,
    actions: [SUBMIT_QA_WORK_ORDER_REQUEST, SUBMIT_QA_WORK_ORDER_SUCCESS, SUBMIT_QA_WORK_ORDER_FAILURE],
    schema
  })
}



// WEBPACK FOOTER //
// ./src/actions/qa-work-orders.js